<template>
  <div>
    <div class="head-title">客服欢迎语列表</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、可以给客服设置欢迎语，欢迎语就是客户刚进客服群的时候会自动发一个欢迎语消息。
          </p>
          <p>2、如果客服本身没有单独的欢迎语会使用通用欢迎语。</p>
          <p>
            3、如果要设置小程序菜单的页面路径格式必须是.html结尾的小程序页面链接，如/pages/activity/smart-card.html，否则无法跳转到小程序。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <div class="header-menu">
        <div class="menu-left">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd"
            >新建客服欢迎语</el-button
          >
        </div>
      </div>
      <div class="container">
        <el-table :data="tableData" v-loading="tableLoading" border >
          <el-table-column
            label="客服名称"
            prop="open_kfid_name"
            style="width:16.66%"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="发送对象"
            prop="scope_name"
            style="width:16.66%"
          ></el-table-column>
          <el-table-column
            label="消息类型"
            prop="type_name"
            style="width:16.66%"
          ></el-table-column>
          <el-table-column
            label="菜单类型"
            prop="menu_type_name"
            style="width:16.66%"
          ></el-table-column>
          <el-table-column label="创建时间" style="width:16.66%">
            <template slot-scope="scope">
              <span style="margin-left: 1.0rem">{{ scope.row.createtime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleDelete(scope.row)"
                style="color:#f00000 !important "
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import pagination from "@/components/Pagination";

export default {
  name: "customerServiceWelcome",
  components: {
    pagination,
  },
  data() {
    return {
      baseURL: this.axios.defaults.baseURL,
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      tooken: "",
      tableData: [],
      tableLoading: true,
    };
  },

  computed: {},

  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getList();
  },

  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    getList() {
      this.axios
        .post(
          "/crm/CustomerServiceWelcome/getWelcome",
          qs.stringify({
            account_id: this.tooken.account_id,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == 1) {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    onAdd() {
      this.$router.push({ path: "/register/user/customerServiceWelcomeAdd" });
    },
    handleEdit(e) {
      this.$router.push({
        name: "customerServiceWelcomeAdd",
        query: {
          id: e.id,
        },
      });
    },
    handleDelete(e) {
      this.$confirm("此操作将永久删除该条数据，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CustomerServiceWelcome/delWelcome",
              qs.stringify({
                id: e.id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getList();
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style  scoped>
body {
  margin: 0;
}
.container{
  margin-top: 2.0rem;
}
</style>
